import * as yup from 'yup';
import { epicTransactionSchema } from './epicLookups';
export const reversePaymentSchema = yup
    .object({
    referenceId: yup.string().required(),
    refundAmount: yup.number().required().positive(),
    createEpicDebit: yup
        .object({
        clientId: yup.string().required(),
        agencyId: yup.string().required(),
        branchId: yup.string().required(),
    })
        .optional()
        .default(undefined),
    updateEpicDebit: yup
        .object({
        transactions: yup.array().of(epicTransactionSchema.required()).required(),
    })
        .optional()
        .default(undefined),
})
    .required();
//# sourceMappingURL=reversePayment.js.map